



























import { Component, Mixins, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { DuplicatedPatientSelectorMixin } from "./mixins";

@Component({
})
export default class DuplicatedPatientSelector extends Mixins(DuplicatedPatientSelectorMixin) {
  mounted() {
    this.clearInformation();
    this.updatePatientDuplicateInformations(this.sourceId);
  }

  @Watch("sourceId")
  onSourceIdUpdated(newValue: string, oldValue: string) {
    this.clearInformation();
    this.updatePatientDuplicateInformations(newValue);
  }

  private updatePatientDuplicateInformations(sourceId: string): void {
    if (!sourceId) { return; }
    this.isFinding = true;
    const repo = DomainRegistry.patient.getPatientRepository();
    repo.getDuplicatedPatients(sourceId)
    .then(patients => {
      this.patients = patients;
    })
    .catch(e => {
      this.$error("重複ID取得エラー", "患者重複ID取得に失敗しました。", e);
    })
    .finally(() => {
      this.isFinding = false;
    });
  }
}
